import { useLocation } from 'react-router-dom';

function useCustomerSuccessPage(): string | undefined {
    const location = useLocation();
    const splitPath = location.pathname.substring(1).split('/');
    const indexOfPage = splitPath.indexOf('customer-success');
    return indexOfPage > -1 ? splitPath[indexOfPage + 1] : undefined;
}
export default useCustomerSuccessPage;
